import { createAction, createNetworkActions } from "~/utils/actions";

export default {
	...createAction("START_FLYTT_PKB"),
	...createAction("SELECT_PKBS"),
	...createAction("CONFIRM_PKB"),
	...createNetworkActions("CREATE_SIGNING_ORDER"),
	...createNetworkActions("CREATE_WORK_ORDERS"),
};
